import { MBase } from "./MBase";
import * as moment from 'moment';

export class Produto extends MBase {
    Id: number;
    Descricao:string = "";
    EmpresaId: number;
    GrupoProdutoId: number;
    GrupoProduto:string;
    Tipo: number = 0;
    Formulacao:string = "";
    Fabricante:string = "";
    UnidadeMedida:string = "";
    PrecoUnitario: number = 0;
    Observacao:string = "";
    IdERP:string = "";
    Cultivar: boolean;
    PrincipioAtivo:string = "";
    DesconsiderarEmRelEspecifico: boolean;
    CultivarId: number;
    NaoControlaEstoque: boolean;
    IsTerceiro: boolean;
    Classificacao: enumClassificacaoProduto;
    NaturezaId: number;
    CodDescricao: string;
    Ativo: boolean = true;

    get descAtivo(): string{
      return this.Ativo ? 'Ativo' : 'Inativo'
    }

    get dataAlteracaoStr(): string{
      return moment(this.DataAlteracao).format('DD/MM/YYYY HH:mm')
    }
}

export enum enumTipo
{
    Produto = 1,
    Servico = 2
}

export enum enumClassificacaoProduto
{
    Insumos = 1,
    Adubos = 2,
    Combustivel = 3,
    Pecas = 4,
    Patrimonio = 5
}
